import React, {useEffect} from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import routes from "../routes/routeDealerAdmin";
import WohlerShortLogo from "assets/img/dashboard/wohler.png";
import MDrawer from 'layouts/m-drawer.js';
import WohlerLogo from "assets/img/mavric_logo_new.png";

export default function DealerAdminRole({ ...rest }) {
  let selectedTile = "";
  if(rest !== undefined && rest.location !== undefined && rest.location.state !== undefined){
    selectedTile = rest.location.state.name;
  }

  const isAuthUser  = useSelector(state => state.isAuthUser);
  const Role        = useSelector(state => state.role);
  const UserId      = useSelector(state => state.userid);
  console.log("Dealer Page Role : ", Role);
  const isDealerAdmin = (Role === "dealeradmin")? true : false;
  console.log("isDealerAdmin Role : ", isDealerAdmin);
  let history = useHistory();
  
  
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  
  if(!isDealerAdmin) {
    history.push('/login');
  }

  return (
    <div>
     
      {<MDrawer 
        routes={routes}
        logo={WohlerLogo}
        slogo={WohlerShortLogo}
        preSelected={selectedTile}
      />}
      
        
    </div>
  );
}